// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"691":"70427163","761":"0efb8a0f","879":"4055aba1"}[chunkId] + ".chunk.js";
};